$(document).ready(function()
{
    if (jQuery('.sortable-table').length){
        jQuery('.sortable-table').DataTable({
            "searching": false,
            "info": false,
            "paging": false
        });
    }

    if ($('.sortable-table-no-index').length)
    {
        $('.sortable-table-no-index').DataTable(
            {
                "searching": false,
                "info": false,
                "paging": false,
                "order" : [],
            });
    }

    if ($('.sortable-table-none').length)
    {
        $('.sortable-table-none').DataTable(
            {
                "searching": false,
                "info": false,
                "paging": false,
                "order": [[ 3, "desc" ]]
            });
    }

    if ($('.sortable-table-lottery').length)
    {
        $('.sortable-table-lottery').DataTable(
            {
                "searching": false,
                "info": false,
                "paging": false,
                "order": [[ 0, "asc" ]],
                "columnDefs": [
                    { "targets": [1,2,3,4], "orderable": false }
                ]

            });


    }

});